import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  .sun-moon {
    display: flex;
    flex-direction: column;
    padding: 0px 30px;

    ${breakpoints.phone} {
      padding: 0px;
    }
  
    .sun-container,
    .moon-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      justify-content: space-evenly;

      .title {
        display: flex;
        flex-direction: column;
        align-items: center;

        .subtitle {
          ${Font.sansBold};
          font-size: 21px;
          line-height: 24px;
          margin-top: 15px;
        }
      }
      p {
        color: ${Color.black000};
        ${Font.sansLight};
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color:${ColorDark.textLight};
          }
        }
      }

      img {
        width: 32px;
        height: 32px;
      }
    }

    .sun-container {
      border-bottom: 1px solid ${Color.greySeparator};
      padding-bottom: 15px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
        }
      }
      @media (max-width: 400px) {
        border: none;
      }

      img {
        width: 32px;
        height: 32px;
      }
    }
    .moon-container {
      padding-bottom: 15px;
      padding-top: 10px;

      @media (max-width: 400px) {
        border-top: 1px solid ${Color.greySeparator};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          border-top: 1px solid ${ColorDark.greySeparator};
          }
        }
      }

      ${breakpoints.phone} {
        padding-bottom: 0px;
      }
    }
  }
`;